export default {"src":"/_next/static/media/COHR.8ce66faa.svg","height":18,"width":18};